import styled from "styled-components";
import { FlexContainer, theme } from "ui";

export const UserEmail = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${theme.colors.neutral.white};
  font-size: ${theme.typography.fontSize.sm.x3};
  font-weight: ${theme.typography.fontWeight["400"]};

  @media ${theme.device.desktopFirst.mobileXL} {
    line-height: 16px;
  }
`;

export const UserName = styled.div`
  font-size: ${theme.typography.fontSize.sm.x5};
  color: ${theme.colors.neutral.white};
  font-weight: ${theme.typography.fontWeight["700"]};
`;

export const IconWrapper = styled.div`
  height: 36px;

  @media ${theme.device.desktopFirst.mobileXL} {
    height: 24px;
  }
`;

export const HeaderUserActionsSection = styled.section`
  width: fit-content;
`;

export const LinkWrapperUser = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  margin-right: 1rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  @media ${theme.device.desktopFirst.tablet} {
    margin-right: 0;
  }

  &::-webkit-tap-highlight-color {
    color: none;
    background: none;
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    cursor: auto;
  }
`;

export const WelcomeWrapper = styled.section`
  display: flex;
  gap: ${theme.space["x1.5"]};
  align-items: center;

  @media ${theme.device.desktopFirst.mobileXL} {
    gap: ${theme.space.x3};
  }
`;

export const UserInformation = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 230px;
  width: 100%;

  @media ${theme.device.desktopFirst.tabletML} {
    display: none;
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    display: flex;
    max-width: 230px;
  }
`;

export const WelcomeMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space["x0.5"]};

  @media ${theme.device.desktopFirst.tabletML} {
    display: none;
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    display: flex;
    gap: ${theme.space.x0};
  }
`;

export const WelcomeMessageTitle = styled.strong`
  font-size: ${theme.typography.fontSize.sm.x5};
  font-weight: ${theme.typography.fontWeight["700"]};
  color: ${theme.colors.neutral["999"]};

  @media ${theme.device.desktopFirst.mobileXL} {
    font-weight: ${theme.typography.fontWeight["500"]};
    color: ${theme.colors.neutral.white};
  }
`;

export const WelcomeMessageLinkContainer = styled.div`
  display: flex;
  gap: ${theme.space.x1};
`;

export const WelcomeMessageLink = styled.div`
  font-size: ${theme.typography.fontSize.sm.x3};
  color: ${theme.colors.neutral["585"]};

  @media ${theme.device.desktopFirst.mobileXL} {
    color: ${theme.colors.neutral.white};
  }
`;

export const WelcomeContainer = styled(FlexContainer)`
  width: 232px;

  &:hover {
    background-color: ${theme.colors.neutral["174"]};
    border-radius: ${theme.space.x2};
    transition: all 0.2s ease-in;

    ${WelcomeMessageTitle}, ${WelcomeMessageLink}, svg > path, circle {
      color: ${theme.colors.neutral["930"]};
      stroke: ${theme.colors.neutral["930"]};
    }
  }

  @media ${theme.device.desktopFirst.tabletML} {
    width: 100%;
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    width: 100%;

    &:hover {
      background-color: transparent;
      border-radius: 0;

      ${WelcomeMessageTitle}, svg > path, circle {
        color: ${theme.colors.neutral["680"]};
        stroke: ${theme.colors.neutral["999"]};
      }

      ${WelcomeMessageLink}, ${UserEmail} {
        color: ${theme.colors.neutral["585"]};
      }
    }
  }
`;

export const FullEmail = styled.span`
  font-size: ${theme.typography.fontSize.sm.x3};
  color: ${theme.colors.neutral["130"]};
  white-space: nowrap;
`;

export const ShowMoreText = styled.span`
  cursor: pointer;
  font-size: ${theme.typography.fontSize.sm.x1};
  color: ${theme.colors.neutral["345"]};
`;

export const UserInitials = styled.span`
  font-weight: bold;
  padding: 0;
  text-decoration: none;
  align-self: center;
  font-size: ${theme.typography.fontSize.sm.x3};
  color: ${theme.colors.neutral.white};
`;

export const ImageCircle = styled.div`
  width: 24px;
  height: 24px;
  background-color: ${theme.colors.secondary["200"]};
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
